import { render, staticRenderFns } from "./RHumanos.vue?vue&type=template&id=2565e84c&scoped=true&"
var script = {}
import style0 from "./RHumanos.vue?vue&type=style&index=0&id=2565e84c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2565e84c",
  null
  
)

export default component.exports